import { TEXT_VARIANTS } from "@gravity-ui/uikit";
import useBreakpoint from "use-breakpoint";
export const DEVICE_BREAKPOINTS = { mobile: 0, tablet: 768, desktop: 1280 };

export const useGravityDevice = () => {
  const { breakpoint } = useBreakpoint(DEVICE_BREAKPOINTS);
  const device = breakpoint ?? "desktop";
  return {
    deviceText: TEXT_VARIANT[device],
    device,
    isMobile: device == "mobile",
    isDesktop: device == "desktop",
    isTablet: device == "tablet",
  };
};

const TEXT_VARIANT = {
  desktop: {
    display: TEXT_VARIANTS[1],
    header: TEXT_VARIANTS[4],
    subheader: TEXT_VARIANTS[6],
    body: TEXT_VARIANTS[9],
    caption: TEXT_VARIANTS[13],
    code: TEXT_VARIANTS[15],
    code_inline: TEXT_VARIANTS[16],
  },
  tablet: {
    display: TEXT_VARIANTS[2],
    header: TEXT_VARIANTS[5],
    subheader: TEXT_VARIANTS[7],
    body: TEXT_VARIANTS[10],
    caption: TEXT_VARIANTS[14],
    code: TEXT_VARIANTS[17],
    code_inline: TEXT_VARIANTS[18],
  },
  mobile: {
    display: TEXT_VARIANTS[3],
    header: TEXT_VARIANTS[5],
    subheader: TEXT_VARIANTS[8],
    body: TEXT_VARIANTS[11],
    caption: TEXT_VARIANTS[14],
    code: TEXT_VARIANTS[19],
    code_inline: TEXT_VARIANTS[20],
  },
};
